import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';
import { NotificationDTO } from '../components/home/home.component';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClientService: HttpClientService) { }

  public getUserMenuTree(userId: number){
    let queryParam = `userId=${userId}`;
    return this.httpClientService.get(`${CONFIG.USER.GETMENUTREE}?${queryParam}`);
  }

  public getTenants(){
    return this.httpClientService.get(`${CONFIG.USER.GETTENANTS}`);
  }

  public refreshToken(data: any) {
    return this.httpClientService.post(`${CONFIG.USER.REFRESHTOKEN}`, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  public getALLMenus(data: any) {
    return this.httpClientService.post(CONFIG.ADMINISTRATION.GETALLMENUS, data);
  }
  public getNotifications(firstName: string) {
    return this.httpClientService.get(`${CONFIG.USER.GETNOTIFICATIONS}?firstName=${firstName}`);
  }
  public getActiveUsers() {
    return this.httpClientService.get(`${CONFIG.USER.GETACTIVEUSERS}`);
  }
  public logout(userId: number) {
    return this.httpClientService.post(`${CONFIG.USER.LOGOUT}?userId=${userId}`, {});
  }

  public getNotificationService(role: string) {
    return this.httpClientService.get(`${CONFIG.USER.GETNOTIFICATIONSERVICE}?role=${role}`);
  }
  public markNotificationAsRead(id: number) {
    return this.httpClientService.post(`${CONFIG.USER.MARKNOTIFICATIONSERVICE}?id=${id}`);
  }
  public sendNotification(payload: NotificationDTO) {
    return this.httpClientService.post(`${CONFIG.USER.SEND_NOTIFICATION}`, payload);
  }

}